import React, { Fragment } from 'react';
import { Redirect } from 'components';
import { cookies, config } from 'helpers';

export function Logout(props) {
  cookies.remove('signing-up', { domain: config.appHost });
  cookies.remove('token', { domain: config.appHost });
  cookies.remove('email');
  return (
    <Redirect to="/login/" />
  );
}
